import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ujmsV2CaseHandoffs } from "../../services/ujmsApi";

const tone = (state) => ({
  IN_CUSTODY: "border-red-300 bg-red-50 text-red-800",
  REVIEW_PENDING: "border-amber-300 bg-amber-50 text-amber-800",
  ACTION_REQUIRED: "border-amber-300 bg-amber-50 text-amber-800",
  CONTESTED: "border-red-300 bg-red-50 text-red-800",
  PENDING: "border-blue-300 bg-blue-50 text-blue-900",
  REVIEW: "border-blue-300 bg-blue-50 text-blue-900",
  ACTIVE: "border-emerald-300 bg-emerald-50 text-emerald-800",
})[state] || "border-slate-200 bg-white text-slate-700";

export const CaseHandoffs = ({ caseId, refreshKey }) => {
  const [handoffs, setHandoffs] = useState(null);
  useEffect(() => {
    let live = true;
    ujmsV2CaseHandoffs(caseId).then((r) => live && setHandoffs(r.data.handoffs)).catch(() => live && setHandoffs([]));
    return () => { live = false; };
  }, [caseId, refreshKey]);
  if (handoffs === null) return null;
  return <section className="ent-panel" data-testid="case-handoffs-panel">
    <header className="flex items-center justify-between px-1.5 pt-0.5"><h3 className="ent-panel-title">connected case handoffs</h3></header>
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-1 p-1.5">
      {handoffs.map((item) => <Link key={item.key} to={`/cases/${caseId}?tab=${encodeURIComponent(item.tab)}`}
        className={`block border px-2 py-1.5 transition-colors hover:brightness-95 ${tone(item.state)}`}
        data-testid={`case-handoff-${item.key}`}>
        <div className="flex items-center justify-between gap-2 text-[11px] font-bold"><span>{item.label}</span><span data-testid={`case-handoff-${item.key}-state`}>{item.state.replace(/_/g, " ")}</span></div>
        <div className="mt-0.5 text-[11px] leading-4" data-testid={`case-handoff-${item.key}-detail`}>{item.detail}</div>
      </Link>)}
    </div>
  </section>;
};